// CAFÉ-SPOT brand monogram - "S" with integrated coffee bean
// Inspired by the official CAFÉ-SPOT identity (gold "S" with bean).
// Rendered in pure SVG so it scales perfectly and matches the dark/gold theme.

export default function Logo({ size = 36, variant = "mark", className = "", showTagline = false }) {
  // variant: "mark" (S only) | "horizontal" (S + wordmark) | "stacked" (S above wordmark)
  const gold = "url(#cs-gold-grad)";

  const Mark = (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="CAFÉ-SPOT"
    >
      <defs>
        <linearGradient id="cs-gold-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#E5C97A" />
          <stop offset="45%" stopColor="#C5A059" />
          <stop offset="100%" stopColor="#9A7A3D" />
        </linearGradient>
        <linearGradient id="cs-gold-grad-soft" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#D4AF37" stopOpacity="0.95" />
          <stop offset="100%" stopColor="#8B6A2F" stopOpacity="0.95" />
        </linearGradient>
      </defs>

      {/* Stylized bold "S" - 3 horizontal bars + 2 vertical connectors */}
      <g fill={gold}>
        <rect x="15" y="12" width="70" height="18" rx="1" />
        <rect x="15" y="12" width="20" height="36" rx="1" />
        <rect x="15" y="42" width="70" height="16" rx="1" />
        <rect x="65" y="42" width="20" height="36" rx="1" />
        <rect x="15" y="70" width="70" height="18" rx="1" />
      </g>

      {/* Coffee bean integrated in the center, slightly right - signature element */}
      <g transform="translate(50 50)">
        <ellipse cx="0" cy="0" rx="7" ry="10" fill="#0A0908" />
        <ellipse cx="0" cy="0" rx="6" ry="9" fill="url(#cs-gold-grad-soft)" />
        <path d="M 0 -8 Q 2.5 -2 0 0 Q -2.5 2 0 8" stroke="#3E2723" strokeWidth="1.2" fill="none" strokeLinecap="round" />
      </g>
    </svg>
  );

  if (variant === "mark") return Mark;

  if (variant === "horizontal") {
    return (
      <div className={`inline-flex items-center gap-3 ${className}`}>
        {Mark}
        <div className="leading-tight">
          <div className="font-serif tracking-[0.12em] text-[#F5F0EB]" style={{ fontSize: size * 0.5, letterSpacing: "0.18em" }}>
            <span className="text-[#C5A059]">CAFÉ-</span>SPOT
          </div>
          {showTagline && (
            <div className="text-[9px] tracking-[0.32em] text-[#A8A39D] uppercase mt-0.5">
              Découvrez · Dégustez · Connectez
            </div>
          )}
        </div>
      </div>
    );
  }

  // stacked
  return (
    <div className={`inline-flex flex-col items-center gap-3 ${className}`}>
      {Mark}
      <div className="text-center">
        <div className="font-serif text-2xl tracking-[0.2em] text-[#F5F0EB]">
          <span className="text-[#C5A059]">CAFÉ-</span>SPOT
        </div>
        {showTagline && (
          <div className="text-[10px] tracking-[0.35em] text-[#A8A39D] uppercase mt-2">
            Découvrez · Dégustez · Connectez
          </div>
        )}
      </div>
    </div>
  );
}
